import React, { Component, useEffect, useState } from "react";
import "../../App.css";
import { Container, Row, Col } from "react-bootstrap";
import Axios from "axios";
import ReactTooltip from "react-tooltip";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { FaUserTimes } from "react-icons/fa";
import {
  IoBan,
  IoCheckmark,
  IoCloseSharp,
  IoTimerOutline,
} from "react-icons/io5";
import ClipLoader from "react-spinners/ClipLoader";
import DeclineRefundRequestModal from "../../modals/refunds/DeclineRefundRequestModal";
import ApproveRefundModal from "../../modals/refunds/ApproveRefundModal";

const RefundRequests = () => {
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [refundId, setRefundId] = useState(null);
  const [refundAmount, setRefundAmount] = useState(null);

  const { eventid, eventname, is_sponsorship } = location.state || {};
  const [requests, setRequests] = useState([]);
  const [successError, setSuccessError] = useState();
  const [errorDisplay, setErrorDisplay] = useState();
  const [error, setError] = useState();
  const [count, setCount] = useState(0);
  const [loadingApprove, setLoadingApprove] = useState(false);
  const [loadingDecline, setLoadingDecline] = useState(false);
  const [declineBtn, setDeclineBtn] = useState("warning-btn");
  const [appproveBtn, setAppproveBtn] = useState("cancel-btn");
  const [processingId, setProcessingId] = useState(null);
  const [autoApprove, setAutoApprove] = useState(false);
  const [refundPolicyLocked, setRefundPolicyLocked] = useState(0);

  const baseURL = "https://karamale.com/apps/kscanner/webservices.php";

  useEffect(() => {
    Axios.get(
      `${baseURL}?query=GET-REFUND-GOVERNANCE-RULES&eventid=${eventid}`,
      {
        withCredentials: true,
      }
    )
      .then((response) => {
        setAutoApprove(response.data.autoApprove);
        setRefundPolicyLocked(response.data.refundPolicyLocked ?? 0);
      })
      .catch((error) => {
        alert(error);
      });

    Axios.get(`${baseURL}?query=GET-REFUND-REQUESTS&event_id=${eventid}`, {
      withCredentials: true,
    })
      .then((res) => {
        if (res.data.status === "failed") {
          setRequests([]); // no refunds found
        } else {
          setRequests(res.data); // array of refund objects
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [count]);

  const handleApproveClick = (refund_id, ticketNumber, refundAmount) => {
    setSelectedTicket(ticketNumber);
    setRefundId(refund_id);
    setRefundAmount(refundAmount);
    setShowApproveModal(true);
  };

  const handleDeclineClick = (refund_id, ticketNumber) => {
    setSelectedTicket(ticketNumber);
    setRefundId(refund_id);
    setShowModal(true);
  };

  const handleDecisionSubmit = async (id, approve, reason = "") => {
    const endpoint = approve ? "approved" : "declined";
    setProcessingId(refundId ?? id);
    setShowApproveModal(false);
    setShowModal(false);

    const data = new FormData();
    data.append("reason", reason);
    data.append("endpoint", endpoint);
    data.append("id", refundId ?? id);
    data.append("query", "REFUND-REQUEST-RESPONSE");

    await Axios({
      method: "POST",
      url: baseURL,
      data: data,
      withCredentials: true,
    })
      .then((res) => {
        if (res.data.status === "success") {
          setErrorDisplay("block");
          setError(res.data.message);
          setSuccessError("success-login");
          setCount(count + 1);
        } else {
          setErrorDisplay("block");
          setError(res.data.message);
          setSuccessError("error-login");
        }
        setProcessingId(null);
      })
      .catch((err) => {
        setProcessingId(null);
        alert(err);
        console.log(err);
      });
    setTimeout(() => {
      setErrorDisplay("none");
    }, 5000);
  };

  return (
    <div>
      <div className={"h-divider w-100 mb-4"} />
      <div className="row">
        <div className="col-12 p-0">
          <h5>Refund Requests</h5>
          <div
            className={autoApprove === 1 ? "alert alert-info p-2" : "d-none"}
          >
            <span>
              Refunds are currently being automatically processed by Karamale.
            </span>
            <br /> Each request below will be evaluated and actioned without
            organizer intervention — using your configured refund rules if
            available, or Karamale's default system policies if not. Manual
            approval and decline actions are disabled while automation is
            active. You can switch to manual review at any time in your event
            configuration settings.
          </div>
        </div>
      </div>
      <div className="table-responsive">
        <table className="table table-bordered w-100">
          <thead>
            <tr>
              <th className="td-bottom-line-map">Requested Date</th>
              <th className="td-bottom-line-map">Buyer</th>
              <th className="td-bottom-line-map">Original Amount</th>
              <th className="td-bottom-line-map">Refund</th>
              <th className="td-bottom-line-map">Ticket Number</th>
              <th className="td-bottom-line-map">Reason</th>
              <th className="td-bottom-line-map" width="100">
                Comments
              </th>
              <th className="td-bottom-line-map">Status</th>
              <th className="td-bottom-line-map">Actions</th>
            </tr>
          </thead>
          <tbody>
            {requests.length === 0 && (
              <tr>
                <td colSpan="9">
                  🙌 Zero refund requests so far — looks like your attendees are
                  happy!
                </td>
              </tr>
            )}
            {requests.length > 0 &&
              requests.map((item) => (
                <tr key={item.id}>
                  <td className="text-grey">{item.requested_at}</td>
                  <td>{item.buyer_name}</td>
                  <td>R{item.original_amount}</td>
                  <td>R{item.amount_refunded}</td>
                  <td>{item.ticket_number}</td>
                  <td>{item.refund_reason}</td>
                  <td>{item.comments}</td>
                  <td>
                    {item.status === "declined" ? (
                      <IoBan size={22} color={"red"} />
                    ) : item.status === "cancelled" ? (
                      <IoCloseSharp size={22} color={"red"} />
                    ) : item.status === "approved" ? (
                      <IoCheckmark size={22} color="green" />
                    ) : (
                      <IoTimerOutline size={22} color={"orange"} />
                    )}{" "}
                    {item.status === "approved" ? item.source : ""}{" "}
                    {item.status}
                  </td>
                  <td className="text-center">
                    {item.status !== "pending" ? (
                      <label className="text-grey">No action required</label>
                    ) : (
                      <>
                        <div
                          className={
                            processingId === item.refund_id ? "d-none" : ""
                          }
                        >
                          <button
                            type="button"
                            // onClick={() =>
                            //   handleDecisionSubmit(item.refund_id, true)
                            // }

                            onClick={() =>
                              handleApproveClick(
                                item.refund_id,
                                item.ticket_number,
                                item.amount_refunded
                              )
                            }
                            className={
                              processingId === item.refund_id
                                ? "btn-disabled text-bold mb-2"
                                : item.auto_approve === 1 &&
                                  item.status !== "pending"
                                ? "btn-disabled text-bold mb-2"
                                : "cancel-btn w-auto mb-2"
                            }
                            disabled={
                              item.auto_approve === 1 &&
                              item.status !== "pending"
                                ? true
                                : false
                            }
                          >
                            Approve
                          </button>
                          &nbsp;&nbsp;
                          <button
                            type="button"
                            onClick={() =>
                              handleDeclineClick(
                                item.refund_id,
                                item.ticket_number
                              )
                            }
                            disabled={
                              processingId === item.refund_id
                                ? true
                                : item.auto_approve === 1 &&
                                  item.status !== "pending"
                                ? true
                                : false
                            }
                            className={
                              processingId === item.refund_id
                                ? "btn-disabled text-bold"
                                : item.auto_approve === 1 &&
                                  item.status !== "pending"
                                ? "btn-disabled text-bold"
                                : "warning-btn w-auto"
                            }
                          >
                            Decline
                          </button>
                        </div>
                        {processingId === item.refund_id ? (
                          <label className="text-grey mb-0">
                            <ClipLoader
                              color={"grey"}
                              loading={true}
                              size={20}
                            />
                            <br />
                            Processing
                          </label>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <div
        className={successError}
        style={{ display: errorDisplay, textAlign: "center" }}
      >
        {error}
      </div>
      <DeclineRefundRequestModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSubmit={(reason) => handleDecisionSubmit(refundId, false, reason)}
        ticketNumber={selectedTicket}
        refundId={refundId}
      />

      <ApproveRefundModal
        isOpen={showApproveModal}
        onClose={() => setShowApproveModal(false)}
        onConfirm={() => handleDecisionSubmit(refundId, true)}
        ticketNumber={selectedTicket}
        refundAmount={refundAmount}
      />
    </div>
  );
};

export default RefundRequests;
